import { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import type { ModalSystemProps } from '@/global/providers/ModalProvider';
import { apiGetSchoolById, apiSchoolBalanceUpdate } from '@/modules/schools/services/school.service';
import { toast } from 'react-toastify';

interface Props {
    schoolId: number;
}

export function SchoolChangeBalanceDialog({schoolId, open, close}: ModalSystemProps<Props>) {
    const {data: school} = apiGetSchoolById(schoolId);
    const {mutate, isPending} = apiSchoolBalanceUpdate();
    const [amount, setAmount] = useState<number | undefined>(0);
    const [comment, setComment] = useState<string>('');

    const theoryBalance = (amount ?? 0) + (school?.balance ?? 0);

    const save = () => {
        if (!amount) {
            toast.error('Введите сумму для изменения');
            return;
        }
        mutate({schoolId, count: amount, comment}, {
            onSuccess: () => {
                toast.success('Баланс успешно изменён!');
                close(0);
            }
        });
    };

    return (
        <Dialog
            open={open}
            onClose={() => close()}
            maxWidth="sm"
        >
            <DialogTitle>
                Изменить баланс
            </DialogTitle>
            <DialogContent sx={{width: '500px'}}>
                <Typography sx={{mb: 1}}>
                    Изменение баланса школы
                    {' '}
                    <i>
                        {school?.title}
                    </i>
                </Typography>
                <Typography sx={{mb: 1}}>
                    Текущий баланс школы:
                    {' '}
                    <b>
                        {school?.balance}
                        {' '}
                        ₸
                    </b>
                </Typography>
                <TextField
                    label="Изменить баланс на"
                    fullWidth
                    value={amount}
                    type="number"
                    onChange={(e) => setAmount(e.target.value ? +(e.target.value) : undefined)}
                    sx={{mt: 2, mb: 1}}
                />
                <TextField
                    label="Комментарий"
                    multiline
                    minRows={3}
                    fullWidth
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    sx={{mt: 2, mb: 1}}
                />
                {
                    theoryBalance >= 0 ? (
                            <Alert severity={'warning'}>
                                После изменение баланс автошколы составит
                                {' '}
                                {theoryBalance}
                                {' '}
                                ₸
                            </Alert>
                        )
                        : (
                            <Alert severity={'error'}>
                                Внимание! Баланс не может быть отрицательным.
                            </Alert>
                        )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => close()}>
                    Закрыть
                </Button>
                <LoadingButton
                    onClick={save}
                    variant="contained"
                    loading={isPending}
                >
                    Сохранить
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};
